import { styled } from '@mui/material'
import { FC, memo } from 'react'
import { ReactComponent as IconNoData } from './no-data.svg'

const NoDataWrap = styled('div')`
  display: flex;
  flex-direction: column;
  // width: 100%;
  height: 100%;
  min-height: 200px;
  align-items: center;
  justify-content: center;
  text-align: center;

  svg {
    margin: 0 0 0 -20px;
  }

  p {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    margin: 0 0 0 -20px;
    color: ${({ theme }) => theme.color.text60};
  }
`

export const NoData: FC<{
  width?: string
  height?: string
  text?: string
  className?: string
}> = memo(
  ({ text = 'No data', width = '100%', height = '100%', className = '' }) => {
    return (
      <NoDataWrap style={{ width, height }} className={className}>
        <IconNoData />
        <p>{text}</p>
      </NoDataWrap>
    )
  },
)
